import React, { useEffect } from 'react';

import {
  ErrorContent,
  ErrorTextContainer,
  FullScreenOverlay,
  OverlayContent
} from './SignUpFormModal.styled';
import { Loader } from 'components/Loader/Loader';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Heading } from 'components/v2/Typography/Heading';
import { utils } from 'kb-shared';

import { SignUpFormModalProps } from './SignUpFormModal.types';

const { KBContacts } = utils;

export const SignUpFormModal = (props: SignUpFormModalProps) => {
  const {
    referralSourcesLoadStatus,
    timeZonesLoadStatus,
    locationsLoadStatus,
    patientInterestLoadStatus
  } = props;
  const loadStatuses = [
    referralSourcesLoadStatus,
    timeZonesLoadStatus,
    locationsLoadStatus,
    patientInterestLoadStatus
  ];
  const modalVisible = loadStatuses.some(s => !s);
  const loaderVisible = loadStatuses.some(s => s == null);

  useEffect(() => {
    if (!modalVisible) return;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [modalVisible]);

  if (!modalVisible) return null;

  return (
    <FullScreenOverlay role="dialog" aria-label="Loading Sign Up Form">
      <OverlayContent>
        <Heading tag="h2" styledAs="h2" noMargin>
          Loading Sign Up Form
        </Heading>
        {loaderVisible ? (
          <Loader />
        ) : (
          <ErrorContent>
            <ErrorTextContainer>
              <span>
                We are sorry, we were unable to load this form.
                <br />
                Please reload the page, or contact us at{' '}
                <a className="link" href={`mailto:${KBContacts.navigatorEmail}`}>
                  {KBContacts.navigatorEmail}
                </a>
                .
              </span>
            </ErrorTextContainer>
            <Button label="Reload" onClick={() => window.location.reload()} />
          </ErrorContent>
        )}
      </OverlayContent>
    </FullScreenOverlay>
  );
};
